import React, { useState, useEffect } from "react"
import Toggle from "react-toggle"
import { FormattedMessage } from "react-intl"
import { HttpError, isError } from "../../state/helpers/Error"
import Triggerable from "../../state/triggerable/Triggerable"
import TriggerableService from "../../state/triggerable/TriggerableService"
import {
    CONVERT_QUOTE_COMMAND,
    FULLY_PAID_QUOTE_TRIGGER,
    TRIGGERABLE_TYPE_CONVERT_QUOTE
} from "../../state/triggerable/triggerableTypes"

const QuoteToInvoiceConversionToggleComponent = () => {
    const [triggerable, setTriggerable] = useState<null | Triggerable>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        (async() => {
            const res = await TriggerableService.get(TRIGGERABLE_TYPE_CONVERT_QUOTE)
            if (!isError(res)) {
                setTriggerable(res)
                setLoading(false)
            }
        }
        )()
    }, [])

    const toggleTriggerable = async () => {
        let res: HttpError | Triggerable | null = null
        if (triggerable == null && loading == false) {
            res = await createConvertQuoteToInvoiceTriggerable()
        } else if (triggerable != null) {
            res = await TriggerableService.toggle(triggerable.getId(), !triggerable.isEnabled())
        }

        if (!isError(res) && res != null) {
            setTriggerable(res)
        }
    }

    return (
        <div className="row p-2">
            <label className="col-3 col-form-label text-align-right">
                <FormattedMessage 
                    id="settings.automation_settings.convert_fully_paid_quote_label"
                    defaultMessage="Convert fully paid quote to invoice"
                />
            </label>

            <div className="col-9 d-flex align-items-center">
                <Toggle 
                    defaultChecked={false}
                    checked={triggerable?.isEnabled() ?? false}
                    icons={false}
                    onChange={toggleTriggerable}
                />
            </div>
        </div>
    )
}

const createConvertQuoteToInvoiceTriggerable = async () => {
    return TriggerableService.create(
        TRIGGERABLE_TYPE_CONVERT_QUOTE,
        FULLY_PAID_QUOTE_TRIGGER,
        CONVERT_QUOTE_COMMAND,
        {},
    )
}

export default QuoteToInvoiceConversionToggleComponent


// WEBPACK FOOTER //
// ./src/automation/components/QuoteToInvoiceConversionToggleComponent.tsx